import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate=useNavigate();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      textAlign="center"
      bgcolor="#f5f5f5"
    >
      <Typography variant="h1" color="error" fontWeight="bold">
        404
      </Typography>
      <Typography variant="h5" color="textSecondary" mt={2}>
        Oops! The page you're looking for doesn't exist.
      </Typography>
      <Button
        component={'div'}
        className="submit-button"
        sx={{ mt: 3 }}
        onClick={()=>navigate('/')}
      >
        Go Home
      </Button>
    </Box>
  );
};

export default NotFound;
